import React, { useEffect, useState } from "react";
import { HiMinus, HiPlus } from "react-icons/hi";

export const UnitFieldSymbols = ({
  id,
  label,
  labelClassName,
  inputClassName,
  placeholder,
  onChange,
  value,
  onFocusEffect,
  onFocusEffectColor,
  onClick,
  onMouseOver,
  type,
  maxLength,
  autoComplete,
  name,
  spellCheck,
  disabled,
  className,
  min,
  defaultValue,
  accept,
  isRequired
}) => {
  const [inputValue, setInputValue] = useState(value ? value : (defaultValue ? defaultValue : 0));


  const handleStepDown = () => {
    if (!disabled) {
      setInputValue((prevValue) => {
        let newValue = 0;
        if (prevValue === 0) {
          newValue = Number(prevValue);
        } else {
          newValue = Number(prevValue) - 1;
        }

        if (onChange) onChange({ target: { value: newValue } });
        return Number(newValue);
      });
    }
  };

  const handleStepUp = () => {
    if (!disabled) {
      setInputValue((prevValue) => {
        const newValue = Number(prevValue) + 1;
        if (onChange) onChange({ target: { value: newValue } });
        return Number(newValue);
      });
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (onChange) onChange(e);
  };


  useEffect(() => {
  }, [inputValue]);

  return (
    <div
      className={`d-flex flex-column align-items-start ${disabled ? "opacity-50 pointer-events-none" : ""}`}
    >
      {label && (
        <label
          className={`${labelClassName ? labelClassName : ""} form-label text-black w-100`}
        >
          {label}{isRequired && (<span className="text-danger">*</span>)}
        </label>
      )}
      <div
        className={`d-flex mt-1 align-items-center h-property-input border-custom background-white ${className ? className : ""}`}
      >
        <button
          className={`btn-plus-minus btn p-0 me-2 text-black`}
          onClick={handleStepDown}
          disabled={disabled}
        >
          <HiMinus className={`fs-5 ${inputValue === 0 ? "grey-light" : "text-black"}`} />
        </button>
        <input
          id={id}
          className={`${inputClassName ? inputClassName : ""} form-control border-none text-center background-white text-black py-2 px-2`}
          disabled={true}
          placeholder={placeholder}
          type={type || "text"}
          onChange={handleChange}
          onClick={onClick}
          onMouseOver={onMouseOver}
          maxLength={maxLength || null}
          autoComplete={autoComplete}
          value={inputValue}
          name={name}
          spellCheck={spellCheck}
          min={min}
          accept={accept}
        />
        <button
          className={`btn-plus-minus btn text-black p-0 ms-2`}
          onClick={handleStepUp}
          disabled={disabled}
        >
          <HiPlus className="fs-5"/>
        </button>
      </div>
    </div>
  );
};
